import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormControl } from '@angular/forms';
import { DwComponent, DwComponentType, DwExpressionService, DwMetaDataFormApi, DwMetaDataFormStateService, 
         DwMetaDataService, DwMetaDataServiceToken, DwSectionBaseComponent, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken, 
         DwLookupSearchType, DwOrmDataService, DwOrmDataServiceToken, DwContext } 
         from '@devwareapps/devware-cap';
import { debounceTime } from 'rxjs/operators';
import { AppMetaDataLookups, AppMetaDataService } from '../../../../meta-data/app-meta-data.service';
import { AccidentsMetaDataItemNames, WorkplaceAccidentEntity } 
          from '../../meta-data/accidents-meta-data.service';
import { Observable, of } from 'rxjs';
import * as moment_ from 'moment';
import { exp } from 'mathjs';
const moment = moment_;

@DwComponent({
  name: 'Accidents UI Util',
  key: 'accidentsUiUtil',
  componentType: DwComponentType.formSection,
  isGlobal: false,
  parentItemName: AccidentsMetaDataItemNames.WorkplaceAccident,
})
@Component({
  selector: 'accidents-ui-util',
  template: ` 
  `
})
export class AccidentUiUtilComponent extends DwSectionBaseComponent implements OnDestroy {
   formApi: DwMetaDataFormApi;
   variables: AccidentsVariableContext;

  constructor(
    dwExpressionService: DwExpressionService,
    protected dwUiConfigRegistryService: DwUiConfigRegistryService,
    @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
    @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
    private dwFormStateService: DwMetaDataFormStateService
  ) {
    super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
    this.formApi = this.dwFormStateService.state.formApi;
  }
  ngOnInit(): void {
  }

  setupComponentComplete() {
    this.runAfterFormDataLoaded(() => this.setupSubscriptions());
  }

  private setupSubscriptions() {
    const requestEntity = this.formApi.getFormData<WorkplaceAccidentEntity>();
    this.subscriptions.push(this.formApi.getFormDataChanges<WorkplaceAccidentEntity>(400).subscribe(entity => {
      this.handleUpdate(entity);
    }));
  }
  ngOnDestroy(): void {
    for(const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  handleUpdate(data: WorkplaceAccidentEntity) { 
    this.variables = this.variables ?? this.getVariableContext(this.context);
    const isNumeric = (val: string) : boolean => !isNaN(Number(val));
    const medical: number = isNumeric(data.MedicalWachter) ? Number(data.MedicalWachter) : 0;
    const expense: number = isNumeric(data.WageExpenseWachter) ? Number(data.WageExpenseWachter) : 0;
    const oop: number = medical + expense;
    this.formApi.patchContextData(this.formApi.getFormConfig().variableContextDataKey, { OverallOOP: oop });
  }
  private getVariableContext(context: DwContext): AccidentsVariableContext {
    for (let contextName in context) {
        if (context.hasOwnProperty(contextName)) {
            if (contextName.indexOf('variable_contex_') == 0) {
                return context[contextName].value as AccidentsVariableContext;
            }
        }
    }

    return null;
}

}
export interface AccidentsVariableContext {
    OverallOOP?: number;
}
